import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output, QueryList,
  ViewChildren,
  HostListener
} from '@angular/core';
import {ToolsService} from "../../services/toolsService/tools.service";
import {appInjector} from "../../classes/appInjector";
import {ImageryProviderService} from "../../services/imageryProvider/imagery-provider.service";
import {BehaviorSubject, interval, Observable, Subject} from "rxjs";
import "rxjs-compat/add/observable/fromEvent";
import {debounceTime} from "rxjs/operators";
import {BreakpointObserver} from "@angular/cdk/layout";
import {CesiumAdapterService} from "../../services/cesiumAdapter21/cesium-adapter.service";
import {MyPositionService} from "../../services/myPosition/my-position.service";
import {MapPosition} from "../../models/MapPosition";
import {isDisablePreload} from "../../../configs/view_only";
import {DomEventsService} from "../../services/dom-event-services/dom-events.service";
import {MultiSelectItemsService} from '../../services/multiSelectItemsService/multi-select-items.service';
import {OverlayService} from '../../services/overlay/overlay.service';

declare var jQuery;
declare const Yiit;

@Component({
  selector: 'app-drawing-editor-tools',
  templateUrl: './drawing-editor-tools.component.html',
  styleUrls: ['./drawing-editor-tools.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DrawingEditorToolsComponent implements OnInit, AfterViewInit {

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler() {
      this.view.preventDrawingFigure();
      this.cd.detectChanges();
  }

  @HostListener('document:click', ['$event']) onClick(event) {
    if(jQuery(event.target).hasClass('es-tool-item') || jQuery(event.target).closest('.es-tool-item').length > 0){
      return;
    }
    else if(jQuery(event.target).hasClass('drawing-tool-wrapper') || jQuery(event.target).closest('.drawing-tool-wrapper').length > 0){
      // this.view.endDrawingFigure();
      this.view.clearDrawingTool();
      this.cd.detectChanges();
    }
  }

  @Output() setCurrentTool: EventEmitter<any> = new EventEmitter<any>();

  public openCategoryList = [];
  protected currentTool = null;
  private tools;
  public logoPath = 'assets/images/logo.png';
  private currentDropdown = null;
  private currentParentLi = null;
  private oldHeight = 0;
  private showToolsChevron = false;
  private currentSubmenu = null;
  protected toolsListLoaded = new BehaviorSubject<boolean>(false);
  public Yiit = Yiit;

  get isToolsChevronsVisible(){
    return this.showToolsChevron;
  }

  toolsList = {};

  isHideChevrons = true;

  constructor(
    private provider: ImageryProviderService,
    protected cd: ChangeDetectorRef,
    protected view: CesiumAdapterService,
    protected myPosition: MyPositionService,
    protected domEvents: DomEventsService,
    protected ms: MultiSelectItemsService,
    protected overlayService: OverlayService,
  ) {
    this.tools = appInjector.get(ToolsService);
  }

  @ViewChildren('toolsListDOM') things:QueryList<any>;

  ngOnInit() {
    let self = this;
    this.toolsList = this.tools.getTools();
    this.tools.toolListChanges.pipe(debounceTime(500)).subscribe((toolsList)=>{
      this.toolsList = this.tools.getTools();
      this.toolsListLoaded.next(toolsList);
    });

    if (jQuery && this.things && this.things.length > 0) {
      jQuery(document).on('hide.bs.dropdown', function (e) {
        self.isHideChevrons = true;
        if (self.currentDropdown){
          self.currentParentLi = self.currentDropdown.parent();
          self.currentDropdown.css({top: '0px',left: self.currentParentLi.width()+'px', position: 'absolute'});
          self.currentDropdown = null;
        }
      });

      jQuery(document).on('shown.bs.dropdown', function (e) {
        let li = jQuery(e.target);
        // let of = jQuery(window).height() - li.offset().top - li.height();
        let dd = jQuery(e.target).find('>ul.dropdown-menu');
        let oldOffset = dd.data('oldOffset');
        if (oldOffset){
          dd.css({top: `${oldOffset.top}px`, bottom: 'auto'});
          dd.data('old-offset', null);
        }
        let ddLeft = dd.offset().left;
        if (dd.height() >= jQuery(window).height()) {
          dd.css({bottom: 'auto', left: ddLeft+'px', top: 0+'px', position: 'fixed'});
          //-dd.offset().top
          self.currentDropdown = dd;
          self.isHideChevrons = false;
        }
        else if(dd.offset().top + dd.height() > jQuery(window).height() && dd.height() - dd.offset().top < jQuery(window).height()){
          dd.data('old-offset', {top: dd.offset().top});
          dd.css({bottom: 0+'px', top: 'auto',left: ddLeft+'px', position: 'fixed'});
        }
        else{
          dd.css({top: li.offset().top, left: ddLeft+'px', position: 'fixed'});
        }
      });


      jQuery(document).on('mouseenter', '.dropdown-submenu', function (e){

        self.currentSubmenu = jQuery(this);
        self.calculateSubmenu();
      });

      Observable.fromEvent(window, 'resize')
        .pipe(
          debounceTime(100)
        )
        .subscribe((event) => {
          let toolNavbarList: HTMLDivElement = document.querySelector('.es-navbar-list-wrapper');
          let toolNavbarListInnerWrapper: HTMLDivElement = document.querySelector('.es-navbar-list-inner-wrapper');
          this.oldHeight = 0;
          if(this.showToolsChevron){
            toolNavbarList.style.maxHeight = 'none';
            toolNavbarListInnerWrapper.style.maxHeight = 'none';
          }
          this.checkToolsChevrons();
          this.calculateSubmenu();
        });
    }
  }

  ngAfterViewInit(){
    if(this.things && this.things.length > 0){
      this.things.changes.subscribe(t => {
        document.querySelectorAll('.dropdown-submenu > .dropdown-menu').forEach((item)=>{
          if (this.getHeight(item) >= 300){
            item['style'].minHeight = '300px';
            item['style'].height = '1px';
            item['fakeScroll']('.es-scrollbar', true);
          }
        });
      });

      interval(1000).subscribe(()=>{
        this.checkToolsChevrons();
      })
    }
  }


  private calculateSubmenu(){
    if (!this.currentSubmenu){
      return;
    }
    var childContainer = this.currentSubmenu.find('.dropdown-menu');
    if (childContainer.height() + this.currentSubmenu.offset().top > jQuery(window).height()){
      childContainer.css({top: -4-((this.currentSubmenu.offset().top + childContainer.height()) - jQuery(window).height())+'px', bottom: 'auto'});
    }
    else{
      childContainer.css({top: 0});
    }
  }

  private checkToolsChevrons() {
    let toolNavbar: HTMLElement = document.querySelector('.es-navbar-wrapper');
    let toolNavbarList: HTMLDivElement = document.querySelector('.es-navbar-list-wrapper');
    let toolNavbarListInnerWrapper: HTMLDivElement = document.querySelector('.es-navbar-list-inner-wrapper');
    if (this.oldHeight != toolNavbar.offsetHeight) {
      let sidebarHeightWithOffset = toolNavbarList.offsetTop + toolNavbarList.offsetHeight + toolNavbar.offsetTop;
      let windowHeight = window.innerHeight;

      this.cd.markForCheck();
      this.oldHeight = toolNavbar.offsetHeight;
      this.showToolsChevron = (windowHeight <= sidebarHeightWithOffset);
      let extraHeight = sidebarHeightWithOffset - windowHeight;
      toolNavbarList.style.maxHeight = (toolNavbarList.offsetHeight - extraHeight)+'px';
      toolNavbarListInnerWrapper.style.maxHeight = toolNavbarList.style.maxHeight;
    }
  }

  onDayTogglerChanged(val){
    let name = null;
    name = (val) ? 'Black & White': null;
    this.provider.selectViewModeByName(name);
  }

  scrollDropdownTop(e){
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      if (!this.currentDropdown){
        return;
      }

      if (parseFloat(this.currentDropdown.offset().top) >= 0){
          return;
      }
      let calculateVal = parseFloat(this.currentDropdown.css('top')) + 38;
      this.currentDropdown.animate({top: calculateVal+'px'}, 100);
  }

  scrollDropdownBottom(e){
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    if (!this.currentDropdown){
      return;
    }

    if (parseFloat(this.currentDropdown.height()) + parseFloat(this.currentDropdown.offset().top) <= jQuery(window).height()){
      return;
    }
    let calculateVal = parseFloat(this.currentDropdown.css('top')) - 38;
    this.currentDropdown.animate({top: calculateVal+'px'}, 100);
  }

  scrollToolsListTop(e){
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    let toolsList = jQuery('#toolbar-id');
    if (parseFloat(toolsList.css('marginTop')) === 0){
        return;
    }
    let prevCalc = parseFloat(toolsList.css('marginTop')) + 70;
    if (prevCalc > 0){
      prevCalc = 0;
    }

    toolsList.animate({'marginTop': prevCalc+'px'}, 100);

    // let toolsList = jQuery('#toolbar-id');
    // if (parseFloat(this.currentDropdown.height()) + parseFloat(this.currentDropdown.offset().top) <= jQuery(window).height()){
    //   return;
    // }
    // let calculateVal = parseFloat(this.currentDropdown.css('top')) - 38;
    // this.currentDropdown.animate({top: calculateVal+'px'}, 100);

  }

  scrollToolsListBottom(e){
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    let toolsList = jQuery('#toolbar-id');
    let windowHeight = jQuery(window).height();
    if (parseFloat(toolsList.height()) + parseFloat(toolsList.offset().top) <= windowHeight){
        return;
    }
    let preCalculate = - 70;
    let calcVal = parseFloat(toolsList.css('marginTop'));
    let heightWithOffsets = preCalculate + parseFloat(toolsList.offset().top) + toolsList.height();
    calcVal-= (heightWithOffsets <= windowHeight) ? Math.abs(preCalculate)-(windowHeight-heightWithOffsets) : Math.abs(preCalculate);

    toolsList.animate({'marginTop': calcVal+'px'}, 100);

  }

  private getHeight(el) {
    var el_style      = window.getComputedStyle(el),
      el_display    = el_style.display,
      el_position   = el_style.position,
      el_visibility = el_style.visibility,
      el_max_height = el_style.maxHeight.replace('px', '').replace('%', ''),

      wanted_height = 0;

    // if its not hidden we just return normal height
    if(el_display !== 'none' && el_max_height !== '0') {
      return el.offsetHeight;
    }

    // the element is hidden so:
    // making the el block so we can meassure its height but still be hidden
    el.style.position   = 'absolute';
    el.style.visibility = 'hidden';
    el.style.display    = 'block';

    wanted_height     = el.offsetHeight;

    // reverting to the original values
    el.style.display    = el_display;
    el.style.position   = el_position;
    el.style.visibility = el_visibility;

    return wanted_height;
  }

  isCategory(item) {
    return item && item.hasOwnProperty('items');
  };

  getName(item) {
    if (this.isCategory(item)) {
      return item.category.name;
    }
    return item.name;
  };

  getCategoryOrItemId(item): number {
    if (this.isCategory(item)) {
      return item.category.id;
    }
    return item.id;
  }

  getHint(item) {
    return ((item.hint && item.hint.length) ? item.hint : '');
  }

  hasMenuIcon(item) {
    return (this.getMenuIcon(item) && this.getMenuIcon(item).length > 0);
  };

  getMenuIcon(item) {
    if (this.isCategory(item)) {
      return item.category.menu_icon;
    }
    return item.menu_icon;
  };

  getSubcategoryMenuIcon(item){
    return item.menu_icon;
  }

  getItems(item){
    if (item){
      return item.items;
    }
    return null;
  }

  toggleCategoryOpen(category){
    if (this.openCategoryList.indexOf(category.category.id) >= 0){
      this.openCategoryList.splice(this.openCategoryList.indexOf(category.category.id), 1)
    }
    else{
      this.openCategoryList.push(category.category.id)
    }
    this.cd.detectChanges()
  }

  isOpenedCategory(category){
    return this.openCategoryList.includes(category.category.id);
  }

  preventDefault(event){
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  takeTool(tool) {

    if (tool.params) {
      var promptParams = [];
      for (let i in tool.params) {
        if (tool.params.hasOwnProperty(i)) {
          var param = tool.params[i];
          if (param.hasOwnProperty('prompt') && param.prompt) {
            if (['fixedWidth', 'fixedHeight', 'fixed_width', 'fixed_height'].indexOf(i) >= 0) {
              param.value = param.hasOwnProperty('value') ? param.value || 2 : 2;
            } else {
              promptParams.push(i);
            }
          }
        }
      }

      if (promptParams.length > 0) {
        for (let i = 0; i < promptParams.length; i++) {
          var v = '';
          v = prompt(tool.params[promptParams[i]].label, tool.params[promptParams[i]].defaultValue);
          if (!v || v.length == 0) {
            return false;
          }
          tool.params[promptParams[i]].value = v;
        }
      }
    }


    this.currentTool = tool;
    this.setCurrentTool.emit(tool);

    if (tool.type === 'fixed-figure' && this.myPosition.placeObjectsInCurrentPosition) {
      // let windowCoords = Cesium.SceneTransforms.wgs84ToWindowCoordinates(
      //   this.view.viewer.scene, this.view.cesiumConverter.convertFromDegreesToCartesian(new MapPosition(this.myPosition.latestCoords)));
      // console.log(this.myPosition.latestCoords, this.view.cesiumConverter.convertFromDegreesToCartesian(new MapPosition(this.myPosition.latestCoords)));
      this.view.endDrawingFigure({lat: this.myPosition.latestCoords.latitude, lng: this.myPosition.latestCoords.longitude, z: 1});
    } else if (tool.type === 'fixed-figure' && isDisablePreload) {
      this.view.prefetchUrlResource(this.view.getPreparedMapIcon(tool.map_icon));
    }

    this.cd.detectChanges();
  };

  voidClick($event) {
    $event.stopPropagation();
    $event.preventDefault();
    return false;
  };

}
